import Grid from '@mui/material/Grid';

import Icon, { IconName } from '@/components/Icon/Icon';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import useViewPortSize from '@/hooks/useViewportSize';
import useGlobalStyles from '@/styles/global.styles';
import { brandColors } from '@/styles/theme/values/brandColors';

import useStyles from './FeatureList.styles';

interface TextListProps {
  list: string[];
  isOnDark?: boolean;
}

export default function FeatureListRow({
  list,
  isOnDark = true,
}: TextListProps) {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles({ isOnDark });
  const { isExtraSmall, isSmall } = useViewPortSize();
  const isMobile = isSmall || isExtraSmall;

  // biome-ignore lint/correctness/noNestedComponentDefinitions: closes over per-render props
  // biome-ignore lint/correctness/noComponentHookFactories: closes over per-render props
  const Feature = ({ feature }: { feature: string }) => {
    return (
      <div className={classes.featureContent}>
        <Icon
          aria-label='check-icon'
          name={IconName.CHECK}
          color={isOnDark ? brandColors.white : brandColors.primaryMain}
          backgroundColor={
            isOnDark ? brandColors.white : brandColors.primaryMain
          }
          innerColor={isOnDark ? brandColors.primaryMain : brandColors.white}
        />
        <p className={cx(globalClasses.bodyLg, classes.featureBody)}>
          {feature}
        </p>
      </div>
    );
  };

  return (
    <GridContainer fixed gridProps={{ className: classes.featureListRow }}>
      {isMobile ? (
        // biome-ignore lint/complexity/useOptionalChain: Automated migration to Biome
        list &&
        list.map((feature, index) => (
          <Grid
            className={classes.featureItem}
            key={`feature-list-row-${
              // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
              index
            }`}
            size={6}
          >
            <Feature feature={feature} />
          </Grid>
        ))
      ) : (
        <Grid
          className={classes.singleFeatureList}
          size={{
            md: 12,
          }}
        >
          {/** biome-ignore lint/complexity/useOptionalChain: Automated migration to Biome */}
          {list &&
            list.map((feature, index) => (
              <Feature
                feature={feature}
                key={`feature-list-item-${
                  // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
                  index
                }`}
              />
            ))}
        </Grid>
      )}
    </GridContainer>
  );
}
